import { isPcc } from 'user';
import { BULK_OPERATIONS, MISSED_APPOINTMENTS } from '../constants';
export const ENTRY_PERMISSION = 'settings';

export const displayLink = (user, env) => {
  return isPcc(user);
};

export const ENTRY_LINK = {
  path: `/${BULK_OPERATIONS}${MISSED_APPOINTMENTS}`,
  text: 'Missed Appts',
  module: 'missed-appointments',
  component: 'Dashboard',
  displayLink: displayLink,
  permission: ENTRY_PERMISSION,
};
